module.exports = __webpack_public_path__ + "img/DE05670.b4e0851a.png";